import { useEffect, useState } from 'react'

// Returns the percentage [0, 100] of the scroll progress of the page.
const useScrollProgress = () => {
  const [progress, setProgress] = useState(0)

  const handleScrollProgress = () => {
    const currentProgress = window.scrollY
    const scrollHeight = document.body.scrollHeight - window.innerHeight
    if (scrollHeight) {
      setProgress(Number(((100 * currentProgress) / scrollHeight).toFixed(0)))
    }
  }

  useEffect(function setupListeners() {
    // Prevent adding unlimited event listeners (due to hot reload in dev mode).
    window.removeEventListener('scroll', handleScrollProgress, {
      capture: true,
    })
    window.addEventListener('scroll', handleScrollProgress, {
      capture: true,
      passive: true,
    })
    handleScrollProgress()

    return function cleanupListeners() {
      window.removeEventListener('scroll', handleScrollProgress, {
        capture: true,
      })
    }
  }, [])
  return progress
}

export default useScrollProgress
